export const STATUS_LABELS = { paid: "Payé", partial: "Partiel", unpaid: "Pas payé" };

const STATUS_CLASSES = { paid: "badge-paid", partial: "badge-partial", unpaid: "badge-unpaid" };

export function statusClass(status) {
  return STATUS_CLASSES[status] || "badge-unpaid";
}

export function StatusBadge({ status, remaining, fmt }) {
  return (
    <span data-testid={`status-badge-${status}`} className={`${statusClass(status)} inline-flex items-center gap-1 px-2.5 py-1 rounded-full text-xs font-semibold whitespace-nowrap`}>
      <span className="w-1.5 h-1.5 rounded-full" style={{ background: "currentColor" }} />
      {STATUS_LABELS[status] || status}
      {status === "partial" && remaining != null && fmt ? ` · reste ${fmt(remaining)}` : ""}
    </span>
  );
}
